
export default (url, skip) => {
    if (skip) {
        return url;
    } else {
        try {
            let urlBuilder = url;

            urlBuilder = urlBuilder.replace(/\/+[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/gmi, '/[dynamic]');
            urlBuilder = urlBuilder.replace(/(\/+[0-9]+)/gmi, '/[dynamic]');

            return urlBuilder;
        } catch (e) {
            console.error(e);

            return url;
        }
    }
}